import { clsx } from 'clsx';
import AlertTriangle from '@crehana/compass.icons.outline/AlertTriangle';
import CheckmarkCircle from '@crehana/compass.icons.outline/CheckmarkCircle';
import Edit2 from '@crehana/compass.icons.outline/Edit2';
import Email from '@crehana/compass.icons.outline/Email';
import Exit from '@crehana/compass.icons.outline/Exit';
import Flag2 from '@crehana/compass.icons.outline/Flag2';
import Plus from '@crehana/compass.icons.outline/Plus';
import Star from '@crehana/compass.icons.outline/Star';
import Trash2 from '@crehana/compass.icons.outline/Trash2';
import { jsx as _jsx } from "react/jsx-runtime";
var icons = {
  "default": {
    Icon: Flag2,
    colorClassName: 'tw-text-primary-light-100',
    bgClassName: 'tw-bg-primary-light-300',
    borderClassName: 'tw-border-primary-light-200',
    sizes: {
      s: 20,
      m: 28
    }
  },
  success: {
    Icon: CheckmarkCircle,
    colorClassName: 'tw-text-success-500',
    bgClassName: 'tw-bg-success-300',
    borderClassName: 'tw-border-success-100',
    sizes: {
      s: 20,
      m: 28
    }
  },
  warning: {
    Icon: AlertTriangle,
    colorClassName: 'tw-text-warning-600',
    bgClassName: 'tw-bg-warning-300',
    borderClassName: 'tw-border-warning-100',
    sizes: {
      s: 20,
      m: 26
    }
  },
  alert: {
    Icon: Trash2,
    colorClassName: 'tw-text-alert-500',
    bgClassName: 'tw-bg-alert-200',
    borderClassName: 'tw-border-alert-100',
    sizes: {
      s: 20,
      m: 28
    }
  },
  exit: {
    Icon: Exit,
    colorClassName: 'tw-text-neutral-light-700',
    bgClassName: 'tw-bg-neutral-light-400',
    borderClassName: 'tw-border-neutral-light-300',
    sizes: {
      s: 20,
      m: 28
    }
  },
  info: {
    Icon: Email,
    colorClassName: 'tw-text-info-500',
    bgClassName: 'tw-bg-info-200',
    borderClassName: 'tw-border-info-100',
    sizes: {
      s: 20,
      m: 28
    }
  },
  reward: {
    Icon: Star,
    colorClassName: 'tw-text-neutral-light-100',
    bgClassName: 'tw-bg-primary-light-300',
    borderClassName: 'tw-border-primary-light-200',
    sizes: {
      s: 20,
      m: 28
    }
  },
  edit: {
    Icon: Edit2,
    colorClassName: 'tw-text-neutral-light-100',
    bgClassName: 'tw-bg-primary-light-300',
    borderClassName: 'tw-border-primary-light-200',
    sizes: {
      s: 20,
      m: 28
    }
  },
  add: {
    Icon: Plus,
    colorClassName: 'tw-text-neutral-light-100',
    bgClassName: 'tw-bg-primary-light-300',
    borderClassName: 'tw-border-primary-light-200',
    sizes: {
      s: 20,
      m: 28
    }
  }
};
export var ModalIcon = function ModalIcon(_ref) {
  var type = _ref.type,
    size = _ref.size,
    IconProp = _ref.Icon;
  var _icons$type = icons[type],
    IconFromObj = _icons$type.Icon,
    sizes = _icons$type.sizes,
    colorClassName = _icons$type.colorClassName,
    bgClassName = _icons$type.bgClassName,
    borderClassName = _icons$type.borderClassName;
  var Icon = IconProp || IconFromObj;
  return /*#__PURE__*/_jsx("span", {
    className: clsx('tw-flex tw-items-center tw-justify-center tw-border-solid  tw-rounded-full', bgClassName, borderClassName, {
      'tw-w-5.6 tw-h-5.6': size === 'm',
      'tw-border-0.8': size === 'm',
      'tw-w-4 tw-h-4': size === 's',
      'tw-border-0.4': size === 's'
    }),
    children: /*#__PURE__*/_jsx(Icon, {
      size: sizes[size],
      className: colorClassName
    })
  });
};
export default ModalIcon;